export enum BarChartAxisType {
  text,
  number,
  currency,
  date,
}
